var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"milkinside"}},[_c('NavMenu',{attrs:{"isOpenedSideMenu":_vm.isOpenedSideMenu},on:{"sideMenuClicked":_vm.toggleSideMenu,"onRouterClick":_vm.hideSideMenu}}),_c('SideMenu',{attrs:{"isOpened":_vm.isOpenedSideMenu},on:{"onRouterClick":_vm.hideSideMenu}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }